import { render, staticRenderFns } from "./RecentTransactions.vue?vue&type=template&id=fc92aa70&scoped=true"
import script from "./RecentTransactions.vue?vue&type=script&lang=js"
export * from "./RecentTransactions.vue?vue&type=script&lang=js"
import style0 from "./RecentTransactions.vue?vue&type=style&index=0&id=fc92aa70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc92aa70",
  null
  
)

export default component.exports